import { useState } from 'react';

const REEL_MP4 = 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/4dd66139-6471-404d-a208-6a69e496104a_Creative-Reel-TEST-Anna-Schriver_COMPRESSED.mp4?v=298eb3f9ecd9c1896d6ec5285a87f183';
const REEL_THUMB = 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/6db50404-51c3-4015-8e61-423dd058590d_reel-thumbnail-1-Anna-Schriver.jpg?v=930f348e8dad00c5883e7ae4fec9043e';

const MARQUEE_FONT_SIZE = 'clamp(2.5rem, 7.8vw, 7.8rem)';

function MarqueeContent({ color = 'white', extraStyle = {} }: { color?: string; extraStyle?: React.CSSProperties }) {
  return (
    <div className="animate-marquee-projects whitespace-nowrap inline-block" style={extraStyle}>
      <span className="mx-12" style={{ fontWeight: 900, fontSize: MARQUEE_FONT_SIZE, color }}>PROJECTS</span>
      <span className="mx-12" style={{ fontWeight: 100, fontSize: MARQUEE_FONT_SIZE, color }}>PROJECTS</span>
      <span className="mx-12" style={{ fontWeight: 900, fontSize: MARQUEE_FONT_SIZE, color }}>PROJECTS</span>
      <span className="mx-12" style={{ fontWeight: 100, fontSize: MARQUEE_FONT_SIZE, color }}>PROJECTS</span>
      <span className="mx-12" style={{ fontWeight: 900, fontSize: MARQUEE_FONT_SIZE, color }}>PROJECTS</span>
      <span className="mx-12" style={{ fontWeight: 100, fontSize: MARQUEE_FONT_SIZE, color }}>PROJECTS</span>
      <span className="mx-12" style={{ fontWeight: 900, fontSize: MARQUEE_FONT_SIZE, color }}>PROJECTS</span>
      <span className="mx-12" style={{ fontWeight: 100, fontSize: MARQUEE_FONT_SIZE, color }}>PROJECTS</span>
    </div>
  );
}

export default function ReelSection() {
  const [playing, setPlaying] = useState(false);

  return (
    <section id="reel" className="pt-0 pb-4 md:pb-12 overflow-x-hidden" style={{ background: '#0d0d0f' }}>
      {/* PROJECTS Marquee — VHS glitch slice */}
      <div className="relative border-y border-white/10 py-5 md:py-7 overflow-hidden my-12 md:my-20" style={{ position: 'relative' }}>
        <MarqueeContent color="white" />
        <div className="absolute inset-0 pointer-events-none overflow-hidden projects-glitch-red" style={{ top: 0, left: 0, right: 0, bottom: 0 }}>
          <MarqueeContent color="rgb(255, 40, 40)" />
        </div>
        <div className="absolute inset-0 pointer-events-none overflow-hidden projects-glitch-cyan" style={{ top: 0, left: 0, right: 0, bottom: 0 }}>
          <MarqueeContent color="rgb(0, 220, 255)" />
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="mb-3 md:mb-6">
          <h2 className="text-center mb-0 leading-none" style={{ fontSize: 'clamp(3rem, 8vw, 8rem)' }}>
            <span className="text-white" style={{ fontWeight: 900 }}>2026</span>{' '}
            <span className="text-white" style={{ fontWeight: 100, letterSpacing: '-0.04em' }}>REEL</span>
          </h2>
        </div>

        <div
          className="group relative cursor-pointer"
          style={{ aspectRatio: '16/9', overflow: 'hidden', background: '#111113' }}
        >
          {playing ? (
            <div className="absolute inset-0 w-full h-full" style={{ background: '#000' }}>
              <video
                src={REEL_MP4}
                className="w-full h-full object-cover"
                autoPlay
                controls
                playsInline
                preload="metadata"
              />
              <button
                className="absolute top-4 right-4 z-50 w-10 h-10 flex items-center justify-center rounded-full cursor-pointer transition-colors duration-200"
                style={{ background: 'rgba(0,0,0,0.7)', border: '1px solid rgba(255,255,255,0.2)' }}
                onClick={() => setPlaying(false)}
              >
                <i className="ri-close-line text-white text-xl"></i>
              </button>
            </div>
          ) : (
            <div className="absolute inset-0 w-full h-full" onClick={() => setPlaying(true)}>
              {/* Thumbnail — oversized by 4px to prevent edge bleed on scale */}
              <div
                className="absolute group-hover:scale-105 transition-transform duration-700"
                style={{ inset: '-4px', willChange: 'transform' }}
              >
                <img
                  src={REEL_THUMB}
                  alt="2026 Reel"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Dark overlay — also oversized */}
              <div
                className="absolute pointer-events-none"
                style={{
                  inset: '-4px',
                  background: 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.30) 40%, rgba(0,0,0,0.15) 70%, rgba(0,0,0,0.40) 100%)',
                }}
              />

              {/* Black mist edges */}
              <div
                className="absolute pointer-events-none"
                style={{
                  inset: '-4px',
                  background: `
                    radial-gradient(ellipse 160% 80% at 50% 0%,   rgba(0,0,0,0.40) 0%, transparent 65%),
                    radial-gradient(ellipse 160% 80% at 50% 100%, rgba(0,0,0,0.45) 0%, transparent 65%),
                    radial-gradient(ellipse 80% 160% at 0%   50%, rgba(0,0,0,0.30) 0%, transparent 60%),
                    radial-gradient(ellipse 80% 160% at 100% 50%, rgba(0,0,0,0.30) 0%, transparent 60%)
                  `,
                }}
              />

              {/* Play button */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div
                  className="w-20 h-20 flex items-center justify-center border border-white/30 group-hover:border-white group-hover:scale-110 transition-all duration-500"
                  style={{ transition: 'transform 0.5s cubic-bezier(0.22,1,0.36,1), border-color 0.4s ease' }}
                >
                  <i className="ri-play-fill text-white text-4xl ml-1"></i>
                </div>
              </div>

              {/* Label */}
              <div className="absolute bottom-8 left-8">
                <h3 className="text-white text-2xl uppercase mb-2" style={{ fontWeight: 900 }}>2026 Reel</h3>
                <p className="text-white/60 text-sm uppercase tracking-widest">Showreel</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
